module.exports = __webpack_public_path__ + "static/logoTDBank-f47dd387a27a9fe943fe7fcf24b0fd00.jpg";